<template>
  <div>
    <el-row class="main">
      <div class="card-box">
        <!-- 右边卡片 -->
        <div class="card-rb">
          <div class="card-4">
            <el-card>
              <div>
                <el-form :inline="true" class="demo-form-inline" size="mini">
                  <el-form-item label="政策类别:">
                    <el-select v-model="searchList.policyCategories" placeholder="请选择政策类别">
                      <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="咨询标题:">
                    <el-input v-model="searchList.title" placeholder="请输入咨询标题"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="getList()">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="info"  @click="searchReset()">重置</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="three">
                <el-button type="primary" size="mini" @click="addFun()">新增</el-button>
              </div>
              <!-- 表格盒子 -->
              <div class="table_card">
                <el-table
                  ref="singleTable"
                  :data="tableData"
                  highlight-current-row
                  style="width: 100%;margin-top: 16px"
                  border
                >
                  <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
                  <el-table-column align="center" prop="policyCategoriesName" label="政策类别" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center" prop="title" label="咨询标题" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center" prop="createDate" label="创建时间" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center" prop="state" label="状态" :show-overflow-tooltip="true">
                    <template scope="scope">
                      <el-switch
                        v-model="scope.row.state"
                        active-value="0"
                        inactive-value="1"
                        @change="changeStatus(scope.row)"
                      ></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" align="center" width="150">
                    <template slot-scope="scope">
                      <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
                        <button
                          style="color:skyblue"
                          class="iconfont icon-chakan tabBtn"
                          @click="look(scope.row.id,'look')"
                        ></button>
                      </el-tooltip> 
                      <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
                        <button
                          style="color: #2e99cf;"
                          class="iconfont icon-bianji3 tabBtn"
                          @click="look(scope.row.id,'change')"
                        ></button>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                        <button
                          style="color:red"
                          class="iconfont icon-icon7 tabBtn"
                          @click="deletepanduan(scope.row.id,'delete')" key=""
                        ></button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 分页功能 -->
              <!--background背景色 :page-sizes="[10,20]"页码选择器   layout显示什么内容  total总条数 -->
              <el-pagination :page-size="pageConfig.pageSize"  layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
                  :total="pageConfig.total"></el-pagination>
              </el-card> 
          </div>
        </div>
        <!-- 弹框 -->
        <el-dialog title="新增" :visible.sync="dialogFormVisible" width="955px" @close='cancel'>
          <el-form :model="formData" label-width="180px">
            <el-form-item label="政策类别：">
              <el-select class="form_input" :disabled="readonly" v-model="policyCategoriesId"  @change="policyCategoriesChange" placeholder="请选择">
                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </el-form-item> 
            <el-form-item label="社会组织：">
              <el-select class="form_input" :disabled="readonly" v-model="formData.socialOrgId" @change="getListSocialWorker" placeholder="请选择">
                <el-option v-for="item in socialOrgList" :key="item.id" :label="item.orgName" :value="item.id" ></el-option>
              </el-select>
            </el-form-item> 
            <el-form-item label="社会工作者：">
              <el-select class="form_input" :disabled="readonly" v-model="socialWorkerId" @change="socialWorker" placeholder="请选择">
                <el-option v-for="item in socialWorkerList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
              </el-select>
            </el-form-item> 
            <el-form-item label="咨询标题：">
              <el-input class="form_input" :disabled="readonly" v-model="formData.title" ></el-input>
            </el-form-item>
            <el-form-item label="内容：" prop="content" style="margin-top: 10px;margin-bottom: 120px">
              <quillEditor class="form_input" :disabled="readonly" v-model="formData.content" :options="editorOption" style="height:150px"></quillEditor>
            </el-form-item>
            <!-- <el-form-item label="内容">
              <el-input class="form_input" :disabled="readonly" v-model="formData.content"  type="textarea" :row="4"></el-input>
            </el-form-item>  -->
            <el-form-item label="发布平台：">
              <el-checkbox-group v-model="chakeboxList" >
                <el-checkbox :disabled="readonly" label="0">微信公众号</el-checkbox> 
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="状态：">
              <el-radio-group v-model="formData.state">
                <el-radio :disabled="readonly" :label="0">启用</el-radio>
                <el-radio :disabled="readonly" :label="1">禁用</el-radio>
              </el-radio-group> 
            </el-form-item>
            <el-form-item>
              <div class="footer"> 
                <el-button v-if="addsend == true" type="primary" @click="send()" >确 定</el-button> 
                <el-button v-if="editsend == true" type="primary" @click="changeSend()" >修 改</el-button>
                <el-button type="info" @click="cancel()">取 消</el-button>
              </div>
            </el-form-item> 
          </el-form> 
        </el-dialog> 
      </div>
    </el-row>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import editor_option from '../../../utils/editorOption.js'
import { post } from "@/api/requrestHttp";
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      // 富文本配置
      editorOption: editor_option.editorOption,
      policyCategoriesId:'',
      socialWorkerId:'',
      addsend :false,
      editsend:false,
      readonly:false, 
      radio: "1",
      valueSwitch: true,
      checked: true,
      dialogFormVisible: false,
      dialogFormVisiblelook: false,
      sendnum :false,
      chengesendnum:false,
      chakeboxList:[],
      socialOrgList:[],
      socialWorkerList:[],
      options:[], 
      value: "",
      input: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      }, 
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      }, 
      tableData:[],
      formData: { 
        publishPlatform:[]
      },
      formLabelWidth: "130px",
      searchList:{}
    };
  },
  mounted() {
    this.getList();
    this.getListSocialOrg();  
    this.getTypeList();
  },
  methods: {
    policyCategoriesChange(val){
      console.log(val);
      this.formData.policyCategories = val;
    },
    socialWorker(val){
      console.log(val);
      this.formData.socialWorkerId = val;
    },
    getTypeList(){
      post("/admin/policyInformationType/info/listPolicyInformationType",{
        pageSize:999,
        pageNo:1, 
        status:'0'
      }).then(res => {
          console.log(res); 
          this.options = res.content.list
      })
    },
    //获取列表
    getList() { 
      console.log(123);
      post("/admin/policyInformation/info/listPolicyInformation", {
        pageSize: this.pageConfig.pageSize,
        pageNo: this.pageConfig.pageNo,
      }).then((res) => { 
        console.log(res);
        this.tableData = res.content.list;
        this.pageConfig.total = res.content.count
      });
    },
    //获取社会组织列表
    getListSocialOrg: async function () { 
      post("/admin/socialOrg/info/listSocialOrg", {
        pageSize: 999,
        pageNo: 1,
        status:0,
      }).then((res) => { 
        console.log(res);
        this.socialOrgList = res.content.list; 
      });
    },
     //获取社会工作者列表
    getListSocialWorker(val) { 
      console.log(val);
      this.formData.socialWorkerId = '';
      post("/admin/socialWorker/info/listSocialWorker", {
        pageSize: 999,
        pageNo: 1,
        socialOrgId:val,
      }).then((res) => { 
        console.log(res);
        this.socialWorkerList = res.content.list; 
      });
    },
    //改变状态
    async changeStatus(cdata) {   
      let params = cdata; 
      console.log(params);
      post("/admin/policyInformation/info/updatePolicyInformation", params).then((res) => { 
        console.log(res); 
        var msg = "状态";
        msg = msg + (cdata.state == "0" ? "启用" : "禁用");
        if (res.code == 200) {
          this.$message({
            message: msg + "成功",
            type: "success"
          });
        } else {
          console.log(res.message);
          this.$message({
            message: msg + "失败",
            type: "error"
          });
        }
      });  
    },
    //分页
			handleCurrentChange(val) {
				this.pageConfig.pageNo = val;
				this.getList();
			},
    look(id, type) { 
      if(type == 'change'){
        this.addsend = false; 
        this.editsend = true; 
        this.readonly = false;
      } 
      if(type == 'look'){ 
        this.addsend = false; 
        this.editsend = false;
        this.readonly = true;
      }
      this.dialogFormVisible = true;
      post("/admin/policyInformation/info/getPolicyInformation", {
        id: id,
      }).then((res) => {
        if (res.code == 200) { 
            console.log(res);
            this.formData = res.content;
            this.socialWorkerId = this.formData.socialWorkerName
            this.chakeboxList = res.content.publishPlatform.split(",");   
            console.log('this.chakeboxList',this.chakeboxList);
            this.policyCategoriesId =  res.content.policyCategoriesName   
            this.formData.state = Number( this.formData.state );
            console.log(this.formData); 
          }else{
            this.$message({ message: "获取信息详情失败，请检查网络", type: "error" });
          }
      }).catch((e) => {});
    },
    
    cancel(){ 
      this.readonly = false;
      this.policyCategoriesId = '';
      this.formData = {}
      this.chakeboxList = [] 
      this.dialogFormVisible = false;
      this.socialWorkerId = '';
    },
    //删除方法
    deletepanduan: async function (id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => { 
        post("/admin/policyInformation/info/deletePolicyInformation", {
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.getList();
          }else{
            this.$message({ message: "删除失败", type: "error" });
          }
        });
      });
    }, 
    addFun(){ 
      console.log('addFun');   
      this.addsend = true; 
      this.editsend = false;
      this.dialogFormVisible = true;  
    },
    searchReset() {
      this.searchList = {};
      this.fileListImg = [];
      this.getList();
    }, 
    changeSend(){  
        this.chakeboxList = this.chakeboxList + "";
        this.formData.publishPlatform = this.chakeboxList;
        let params = {
          ...this.formData,  
        } 
        console.log(params);
        post("/admin/policyInformation/info/updatePolicyInformation", params).then((res) => {
          if (res.code == 200) {
            this.$message({ message: "修改成功", type: "success" });
            this.dialogFormVisible = false;
            this.getList();
            this.cancel()
          }else{
            this.$message({ message: "修改失败", type: "error" });
          }
        });
    },
    send() {     
      this.chakeboxList = this.chakeboxList + "";
      this.formData.publishPlatform = this.chakeboxList;
      let params = {
          ...this.formData, 
      }  
      post("/admin/policyInformation/info/insertPolicyInformation", params).then((res) => {
        if (res.code == 200) {
          this.$message({ message: "新增成功", type: "success" });
          this.dialogFormVisible = false;
          this.getList(); 
          this.cancel()
        }else{
          this.$message({ message: "新增失败", type: "error" });
        }
        
      });
    },
  }, 
  changedata(id, type){
    
      let publishPlat = this.formData.publishPlatform.toString()
      console.log(publishPlat); 
      let params = Object.assign(this.formData,{
          publishPlatform: publishPlat
      }) 
      console.log(params);
      post("/admin/policyInformation/info/insertPolicyInformation", params).then((res) => {
        console.log(res); 
        if (res.code == 200) {
          this.$message({ message: "新增成功", type: "success" });
          this.dialogFormVisible = false;
          this.getList();
        }else{
          this.$message({ message: "新增失败", type: "error" });
        }
      });
    }, 
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  position: relative;
  .mapdiv {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  .pic {
    height: 50px;
    width: 100%;
    position: absolute;
    bottom: 50px;
    left: 0;
    z-index: 9999;
    background-image: url("../../../assets/images/zhzx.png");
    background-size: 100% 100%;
    .pic-nav {
      width: 50%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }
    .nav-cli {
      cursor: pointer;
      width: 30%;
      height: 80%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 18px;
    }
  }
  .m-lr1 {
    display: flex;
    align-items: center;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    height: calc(100% - 88px);
    width: 20vw;
    background-color: rgba(252, 250, 250, 0.1);
    .m-cli {
      width: 100%;
      height: 50%;
    }
  }
  .m-lr2 {
    z-index: 999;
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    height: calc(100% - 88px);
    width: 20vw;
    background-color: rgba(252, 250, 250, 0.1);
    .m-cli {
      width: 100%;
      height: 50%;
    }
  }
}

// 左上echart盒子
#l-t-chartbox,
#l-b-chartbox,
#r-t-chartbox,
#r-b-chartbox {
  // margin-top: 10%;
  // padding-top: 8%;
  width: 100%;
  height: 100%;
  // background-color: rgb(172, 149, 149);
}
.chart_title {
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}
// 重置按钮和全屏按钮
.mapbox {
  position: relative;
  height: 100%;
  width: 100%;
  .quanping {
    color: #fff;
    font-size: 30px;
    position: absolute;
    right: 20px;
    top: 40px;
    font-weight: 600;
    z-index: 4;
  }
  .chongzhi {
    color: #fff;
    font-size: 32px;
    position: absolute;
    right: 20px;
    top: 90px;
    font-weight: 500;
    z-index: 4;
  }
  .quxiao {
    color: #fff;
    font-size: 30px;
    position: absolute;
    right: 20px;
    top: 140px;
    font-weight: 400;
    z-index: 4;
  }
}
.mapboxactive {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}
.zoomInIcon {
  width: 31px;
  height: 31px;
}
.form_input{
  width: 600px;
}
/deep/.tabBtn {
  font-size: 18px;
}
.footer{ 
  text-align: center;
  margin-left: -140px;
}
</style> 
